export const langsList = ['en', 'de', 'it', 'es', 'fr'];

export const getLocaleData = async () => {
  let locales = {};
  const storage = JSON.parse(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    localStorage.getItem('mage-cache-storage') as string,
  );
  const urlLang = document
    .querySelector('input[name=lang]:checked')
    ?.getAttribute('id')
    ?.replace('flag-', '');
  const storageLang = storage?.lang?.locale || localStorage.getItem('language');
  // TODO: refactor without type assertion, or add comment
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const localeRaw = urlLang || (storageLang as string);
  const locale = langsList.includes(localeRaw) ? localeRaw : 'en';

  await fetch(`/media/translations/${locale}.json`)
    .then((response) => response.json())
    .then((data) => (locales = data))
    .catch((error) => {
      console.error(error);
    });

  return { currentLocale: locale, messages: locales };
};

export const getUserLang = () => {
  const storage = JSON.parse(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    localStorage.getItem('mage-cache-storage') as string,
  );
  return storage?.lang?.locale || 'en';
};

export const getNylasEditorConfig = () => {
  return JSON.parse(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    localStorage.getItem('nylas-editor-session-config') as string,
  );
};

export const getNylasCalendarConfig = () => {
  return JSON.parse(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    localStorage.getItem('nylas-calendar-session-config') as string,
  );
};

export const getNylasCalendarModalConfig = () => {
  return JSON.parse(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    localStorage.getItem('nylas-calendar-modal-session-config') as string,
  );
};

export const getNylasGrant = () => {
  // TODO: refactor without type assertion, or add comment
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return JSON.parse(localStorage.getItem('grant') as string);
};

export const saveCalendarLink = (calendarLink: string) => {
  const CACHE_LOCALSTORAGE = 'mage-cache-storage';

  let mageCacheStorage = JSON.parse(
    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    localStorage.getItem(CACHE_LOCALSTORAGE) as string,
  );
  if (mageCacheStorage && Object.keys(mageCacheStorage).length) {
    mageCacheStorage = Object.assign(mageCacheStorage, {
      customer: { ...mageCacheStorage.customer, calendar_link: calendarLink },
    });
    localStorage.setItem(CACHE_LOCALSTORAGE, JSON.stringify(mageCacheStorage));
  }
};
